import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumWinterDataSummit from '../components/BreadcrumbWinterDataSummit'
import WinterEventComponent from '../components/WinterEventComponent'
import WinterEventSection from '../components/WinterEventSection'

export default function WinterDataSummitEvent() {
  return (
    <div>
      <Header1/>
      <BreadcrumWinterDataSummit/>
      <WinterEventComponent/>
      <WinterEventSection/>
      <Footer/>
    </div>
  )
}
